/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('SalesFilterTemplateEventFactory', function($resource) {
	return $resource(
		'api/salesFilterTemplateEvents/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

/**
 * Factory to get or delete an instance of UserSalesFilterTemplateEventViewDto
 */
angular.module('emsApp').factory('UserSalesFilterTemplateEventViewDtoFactory', function($resource) {
	return $resource(
		'api/user/salesfiltertemplateevent/:id',
		{},
		{
			// Factory is only used to delete a UserSalesFilterTemplateEventViewDto
		}
	);
});
/**
 * Factory to search / retrieve an array of UserSalesFilterTemplateEventListDto's
 */
angular.module('emsApp').factory('UserSalesFilterTemplateEventListDtoSearchFactory', function($resource) {
	return $resource(
		'api/user/salesfiltertemplateevent',
		{},
		{
			query: { method: 'GET', isArray: false },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewSalesFilterTemplateEventFactory', function($resource) {
	return $resource(
		'api/salesFilterTemplateEvents/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all SalesFilterTemplateEvents without the use of paging
angular.module('emsApp').factory('NoPagingSalesFilterTemplateEventFactory', function($resource) {
	return $resource(
		'api/salesFilterTemplateEvents/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllSalesFilterTemplateEventsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/salesFilterTemplateEvents/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});
